import { fireInit } from './fireInit';

import { uploadFileTool } from './uploadFile';

import { updateDocTool } from './updateDoc';
import { getDocsTool } from './getDocs';
import { getDocTool } from './getDoc';

import { deleteDocTool } from './deleteDoc';
import { setDocTool } from './setDoc';

import { whereConds } from './whereConds';
import { whereTool } from './where';

export const firebase = {
  fireInit,

  uploadFile: uploadFileTool,

  getDoc: getDocTool,
  getDocs: getDocsTool,
  updateDoc: updateDocTool,

  deleteDoc: deleteDocTool,
  setDoc: setDocTool,

  whereConds,
  where: whereTool,
};
